import React from 'react'

const Rounds = (props) => {
  return (
    <span className='Round__circle' style={{background: props.color}}></span>
  )
}

export default Rounds